import { getIsMobileApp } from '@udemy/onetrust';
export function attachCheckoutButtonParams(baseUrl) {
  const searchParams = new URLSearchParams();
  if (getIsMobileApp()) {
    searchParams.set('display_type', 'mobile_app');
  }
  if (Array.from(searchParams).length === 0) {
    return baseUrl;
  }
  return `${baseUrl}?${searchParams.toString()}`;
}
//# sourceMappingURL=helpers.js.map